import { useEffect, useState } from 'react';
import { Autocomplete, Chip, TextField } from '@mui/material';
import { toast } from 'react-toastify';
import quizService from '../services/quiz.service';
import skillService from '../services/skill.service';

interface SkillOption { id: number; name: string }

/** Savoir-faire mobilisés par un quiz (Sat : le gain d'une question dépend de la maîtrise estimée de ces SF).
 *  Enregistré à chaque changement, indépendamment du brouillon du quiz. */
export default function QuizSkillsField({ quizId, skills, onSaved }: {
  quizId: number;
  skills: SkillOption[];
  onSaved: (skills: SkillOption[]) => void;
}) {
  const [options, setOptions] = useState<SkillOption[]>([]);

  useEffect(() => {
    skillService.getAll({ page_size: 2000 })
      .then((list) => setOptions(list.map((s) => ({ id: s.id, name: s.name }))))
      .catch(() => setOptions([]));
  }, []);

  const save = async (value: SkillOption[]) => {
    try {
      const updated = await quizService.update(quizId, { skill_ids: value.map((s) => s.id) });
      onSaved(updated.skills ?? value);
    } catch {
      toast.error('Savoir-faire non enregistrés');
    }
  };

  return (
    <Autocomplete
      multiple
      size="small"
      options={options}
      value={skills}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      getOptionLabel={(o) => o.name}
      onChange={(_, value) => save(value)}
      renderTags={(value, getTagProps) => value.map((o, i) => (
        <Chip {...getTagProps({ index: i })} key={o.id} label={o.name} size="small" />
      ))}
      renderInput={(params) => (
        <TextField {...params} margin="normal" label="Savoir-faire mobilisés (Sat)"
          helperText="Le gain d'une question dépend de la maîtrise estimée de ces savoir-faire" />
      )}
    />
  );
}
